import { render, staticRenderFns } from "./SvgLoader.vue?vue&type=template&id=8af716ca&scoped=true"
import script from "./SvgLoader.vue?vue&type=script&lang=js"
export * from "./SvgLoader.vue?vue&type=script&lang=js"
import style0 from "./SvgLoader.vue?vue&type=style&index=0&id=8af716ca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af716ca",
  null
  
)

export default component.exports